<p-accordion
  [(activeIndex)]="activeIndex"
  expandIcon="pi pi-angle-down"
  collapseIcon="pi pi-angle-up"
  styleClass="error-accordion"
>
  <p-accordionTab *ngFor="let errorType of errorAccordions">
    <ng-template pTemplate="header">
      <span class="flex align-items-center justify-between gap-2 w-full">
        <span class="error-header white-space-nowrap">
          {{ errorObject[errorType].errorLabel }}
        </span>
        <span>
          <span
            class="rounded-xl warning-chip"
            *ngIf="errorObject[errorType].type == 'warning'"
          >
            <img
              class="w-[16px] h-[16px]"
              src="/assets/images/planogram-warning-icon.svg"
            />
            {{ errorObject[errorType].count }}
          </span>
          <span
            class="rounded-xl error-chip"
            *ngIf="errorObject[errorType].type == 'error'"
          >
            <img
              class="w-[16px] h-[16px]"
              src="/assets/images/planogram-error-icon.svg"
            />
            {{ errorObject[errorType].count }}
          </span>
        </span>
      </span>
    </ng-template>
    <div
      class="error-message"
      *ngFor="let item of errorObject[errorType].errors"
      (mouseenter)="highLightError(item, true, errorType)"
      (mouseleave)="highLightError(item, false, errorType)"
    >
      <img
        class="w-[16px] h-[16px] mr-2"
        src="/assets/images/planogram-error-icon.svg"
        *ngIf="errorObject[errorType].type == 'error'"
      />
      <img
        class="w-[16px] h-[16px] mr-2"
        src="/assets/images/planogram-warning-icon.svg"
        *ngIf="errorObject[errorType].type == 'warning'"
      />
      <span>{{ item.errorText }}</span>
    </div>
  </p-accordionTab>
</p-accordion>
